import config from "@sg-protect/runtime-config";
import { useWorkspaceId } from "./WorkspaceContext.tsx";

function getMigratePaths(workspaceId: string) {
    return {
        root: `/migrate/${workspaceId}`,
        downloadMigration: `${config.get().home.baseUrl}/api/external-links/download-migration-tool`,
        openMigrateAssessment: `${config.get().home.baseUrl}/api/protect-links/open-migrate-assessment`
    };
}

export function useMigratePaths() {
    const workspaceId = useWorkspaceId();

    return getMigratePaths(workspaceId);
}
